import type * as React from 'react'

import { Textarea, WarningIcon } from '@buffer-mono/popcorn'

import styles from './PromptTextarea.module.css'

/**
 *
 */
function PromptTextarea({
  id,
  name,
  value,
  errorMessage,
  tip,
  placeholder,
  testId,
  onChange,
}: {
  id?: string
  name?: string
  value?: string
  errorMessage?: React.ReactNode
  tip?: React.ReactNode
  placeholder?: string
  testId?: string
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
}): JSX.Element {
  const accessibleDescriptionId = `${id}-description`
  const isInvalid = !!errorMessage

  return (
    <>
      <Textarea
        id={id}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        data-testid={testId}
        aria-invalid={isInvalid}
        aria-describedby={accessibleDescriptionId}
        rows={6}
        resize="none"
        className={styles.textarea}
      />

      {errorMessage && (
        <div id={accessibleDescriptionId} className={styles.error}>
          <WarningIcon size="small" />
          {errorMessage}
        </div>
      )}

      {tip && !isInvalid && (
        <div className={styles.tip}>
          <strong>Pro tip:</strong> {tip}
        </div>
      )}
    </>
  )
}

export { PromptTextarea }
